// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3S64C","upload":"Small_upload__1Qpz1","imageWrap":"Small_imageWrap__3OIDu","removeBtn":"Small_removeBtn__1Xllu"};